module.exports = __webpack_public_path__ + "static/media/extract.dca32916.svg";